<template>
  <v-dialog v-model="showDialogChangeRequestSupport" width="500" persistent>
    <v-card>
      <div class="fti-dialog-header">
        <div class="ml-3">{{ $t('changeRequest')|capitalizeAll }}</div>
        <v-spacer></v-spacer>
        <v-btn flat icon @click="closeDialogChangeRequestSupport">
          <v-icon color="#fff">mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="px-3 py-3">
        <span>{{ $t('currentRequestSkill')|capitalizeAll }}:<label class="ml-2">{{ (currentSkill && currentSkill.id > 0) ? `"${currentSkill.name}"` : $t("noSkill")|capitalize }}</label></span>
        <v-select
          :items="skillList"
          v-model="selectedSkill"
          item-text="name"
          return-object
          solo
          class="fti-select py-2"
          small
        ></v-select>
        <div class="text-xs-right">
          <v-btn color="#3782F0" dark @click="updateRequestSupport" class="fti-btn mr-2" :disabled="!selectedSkill">
            {{ $t("save")|capitalize }}
          </v-btn>
          <v-btn color="white" @click="closeDialogChangeRequestSupport" class="fti-btn mr-2">
            {{ $t("cancel")|capitalize }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";
import FormMixin from "@/mixins/FormMixin";
import AppService from "@/services/app.service";
import StaffService from "@/services/staff.service";

export default {
  name: "DialogChangeRequestSupport",
  mixins: [FormMixin],
  computed: {
    ...mapState(['chatView', 'requestSupportCategories']),
    ...mapState('customer', ['currentCustomer']),
    ...mapState('dialog', ['showDialogChangeRequestSupport']),
  },
  data() {
    return {
      selectedSkill: null,
      currentSkill: null,
      skillList: null,
    }
  },
  watch: {
    showDialogChangeRequestSupport: {
      handler: function() {
        this.setValues()
      },
    },
  },
  methods: {
    ...mapActions('dialog', ['closeDialogChangeRequestSupport']),
    setValues() {
      if (this.showDialogChangeRequestSupport) {
        this.skillList = [];
        this.currentSkill = null;
        this.selectedSkill = null;
        let current_skill_ids = [];
        for (const cat of this.chatView?.livesupport_log?.request_support_categories) {
          current_skill_ids.push(cat.id);
        }
        for (const cat of this.requestSupportCategories) {
          if (current_skill_ids.includes(cat.id)) {
            this.currentSkill = {id: cat.id, name: cat.name}
          } else {
            this.skillList.push({id: cat.id, name: cat.name})
          }
        }
        if (!this.currentSkill) {
          this.currentSkill = {id: 0, name: this.$t("noSkill")}
        } else {
          this.skillList = [
            {id: 0, name: this.$t("noSkill")},
            ...this.skillList
          ]
        }
      } else {
        this.skillList = [];
      }
    },
    updateRequestSupport() {
      StaffService.updateRequestSupport(this.selectedSkill.id).then(() => {
        AppService.toastInfo('Update request support success');
        if (this.selectedSkill.id === 0) {
          this.chatView.livesupport_log.request_support_categories = []
        } else {
          this.chatView.livesupport_log.request_support_categories = [this.selectedSkill.id]
        }
      }).catch((e) => {
        console.error(e)
        AppService.toastError('Update request support failed')
      }).finally(() => {
        this.closeDialogChangeRequestSupport();
      })
    },
  }
}
</script>

<style scoped lang="scss">
.fti-dialog-header {
  display: flex;
  align-items: center;
  background: #0052CC;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  height: 40px;
}

textarea {
  width: 100%;
  background: #F7F7FC;
  padding: 12px;
  min-height: 200px;

  &:focus {
    outline: none
  }
}

.fti-btn {
  text-transform: capitalize;
  font-weight: bold;
  margin: 0 0 12px 0;
}

.icon-block {
  padding-right: 6px !important;
}
</style>
